import React from 'react'
import { Grid as BaseGrid, styled } from '@mui/material'
import { CheckCircle, RemoveCircle, Warning } from '@mui/icons-material'
import { Typography } from '@chilecompra/react-kit'

export const AbilityCertificateLink = styled('span')`
  position: absolute;
  top: 18px;
  right: 24px;
  color: ${props => props.theme.palette.blue[50]};
  cursor: pointer;

  &:hover {
    color: ${props => props.theme.palette.gray[35]};
  }
`

export const Column = styled(({ flexBasis, flexGrow, width, ...props }) => <BaseGrid item {...props} />)`
  &.MuiGrid-root {
    flex-basis: ${props => props.flexBasis};
    flex-grow: ${props => props.flexGrow};
    margin: 0;
    padding: 0 5px;
    width: ${props => props.width};
  }
`
export const Content = styled('section')`
  font-size: 14px;
  line-height: 18px;
  overflow-x: auto;
  padding-bottom: 10px;
  padding-top: 24px;
  width: 100%;
`
export const ErrorIcon = styled(RemoveCircle)`
  &.MuiSvgIcon-root {
    height: 20px;
  }
  align-self: center;
  color: ${props => props.theme.palette.red[50]};
  padding-right: 4px;
  transform: rotate(129deg);
  width: auto;
`

export const ErrorText = styled(Typography)`
  &.MuiTypography-root {
    color: ${props => props.theme.palette.red[50]};
  }
`
export const MessageColumn = styled(Column)`
  &.MuiGrid-root {
    ${props => props.theme.breakpoints.down('lg')} {
      width: 75%;
    }
    ${props => props.theme.breakpoints.down('sm')} {
      width: 100%;
    }
  }
`

export const ProcessesColumn = styled(Column)`
  &.MuiGrid-root {
    width: 50%;
    ${props => props.theme.breakpoints.down('sm')} {
      width: 60%;
    }
  }
`

export const ProcessesDateColumn = styled(Column)`
  &.MuiGrid-root {
    width: 27%;
    ${props => props.theme.breakpoints.down('sm')} {
      width: 100%;
    }
  }
`

export const ProvidersInfoColumn = styled(({ flexBasis, flexGrow, width, ...props }) => <BaseGrid item {...props} />)`
  &.MuiGrid-root {
    flex-basis: ${props => props.flexBasis};
    flex-grow: ${props => props.flexGrow};
    margin: 0;
    padding: 0 5px;
    width: 75%;

    @media (max-width: 425px) {
      width: 50%;
    }
  }
`

export const Row = styled(({ ...props }) => <BaseGrid container {...props} />)`
  &.MuiGrid-root {
    margin: 0 -5px;
    padding: 0;
    flex-direction: ${props => props.direction ?? 'unset'};
    align-items: ${props => props.alignItems};
    justify-content: ${props => props.justify ?? 'unset'};
    height: ${props => props.height ?? 'unset'};
  }
`

export const ProvidersInfoRow = styled(Row)`
  &.MuiGrid-root {
    flex-wrap: nowrap;
  }
`

export const Separator = styled('hr')`
  border: 0;
  border-top: 1px solid ${props => props.theme.palette.custom.gray[75.5]};
  box-sizing: content-box;
  height: 0;
  margin: 5px 0;
  overflow: visible;
`

export const SecondaryText = styled(Typography)`
  &.MuiTypography-root {
    color: ${props => props.theme.palette.brand.black3};
  }
`

export const ProcessesDateText = styled(SecondaryText)`
  &.MuiTypography-root {
    ${props => props.theme.breakpoints.down('sm')} {
      margin: 0 !important;
      padding: 0 1;
      width: 100%;
    }
  }
`

export const StatusColumn = styled(({ flexBasis, flexGrow, width, ...props }) => <BaseGrid item {...props} />)`
  &.MuiGrid-root {
    display: flex;
    align-items: center;
    flex-basis: ${props => props.flexBasis};
    flex-grow: ${props => props.flexGrow};
    margin: -5px 0 0;
    padding: 0 5px;
    width: ${props => props.width};
  }
`

export const Strong = styled('span')`
  font-weight: bold;
`

export const SuccessIcon = styled(CheckCircle)`
  &.MuiSvgIcon-root {
    height: 20px;
  }
  align-self: center;
  color: ${props => props.theme.palette.green[50]};
  height: 20px;
  padding-right: 4px;
  width: auto;
`

export const SuccessText = styled(Typography)`
  &.MuiTypography-root {
    color: ${props => props.theme.palette.green[50]};
    padding-top: 2px;
  }
`
export const UnderlineText = styled(Typography)`
  &.MuiTypography-root {
    text-decoration: underline;
`

export const WarningIcon = styled(Warning)`
  &.MuiSvgIcon-root {
    height: 20px;
  }
  align-self: center;
  color: ${props => props.theme.palette.yellow[50]};
  padding-right: 4px;
  margin-top: -6px;
  width: 20px;
`
